const SIZE_LIMIT = 1024 * 1024 * 30;

export const tronLinkCheck = () => {
  const tronWeb = window.tronWeb;
  if (tronWeb) {
    const address = tronWeb.defaultAddress.base58;
    if (address) {
      return { isInstalled: true, isLogin: true, address: address };
    } else {
      return { isInstalled: true, isLogin: false, address: null };
    }
  } else {
    return { isInstalled: false, isLogin: false, address: null };
  }
};

export const metaMaskCheck = async () => {
  const web3Provider = window.ethereum;
  if (web3Provider) {
    try {
      // 请求用户授权
      web3Provider.enable();
    } catch (error) {
      // 用户不授权时
      console.error("User denied account access");
    }

    let web3js = new window.Web3(web3Provider);
    let accounts = await web3js.eth.getAccounts();
    let address = accounts[0];

    if (address) {
      return { isInstalled: true, isLogin: true, address: address };
    } else {
      return { isInstalled: true, isLogin: false, address: null };
    }
  } else {
    return { isInstalled: false, isLogin: false, address: null };
  }
};

export const fileSizeCheck = (file) => {
  if (file.size > SIZE_LIMIT) {
    return true;
  } else {
    return false;
  }
};

export const typeCheck = (file) => {
  if (!file.type || file.type === "") {
    return true;
  }
  if (
    file.type.indexOf("image") > -1 ||
    file.type.indexOf("video") > -1 ||
    file.type.indexOf("audio") > -1 ||
    file.type.indexOf("application") > -1
  ) {
    return false;
  } else {
    return true;
  }
};

export const addressCheck = (address) => {
  const tronWeb = window.tronWeb;
  if (tronWeb) {
    if (tronWeb.isAddress(address)) {
      return true;
    } else {
      return false;
    }
  }
};
